<div class="flex flex-col gap-6">
    <div class="flex items-center gap-3">
        <p-progress-spinner *ngIf="loading()" strokeWidth="5" [style]="{ width: '25px', height: '25px' }" />
    </div>

    <p-chart type="bar" height="275" [data]="chartData()" [options]="chartOptions"></p-chart>
</div>
